import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import CoursesTab from "../../components/admin/tabs/CoursesTab";
import CourseForm from "../../components/admin/forms/CourseForm";
import AdminLayout from "../../components/admin/AdminLayout";
import useCoursesData from "../../hooks/useCoursesData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminCoursesPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const coursesData = useCoursesData(user);
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh courses data
    coursesData.fetchCourses();
  });

  // Handle update course wrapper
  const handleUpdateCourseWrapper = async (courseData) => {
    if (adminActions.editingCourse) {
      return await adminActions.handleUpdateCourse(adminActions.editingCourse.id, courseData);
    }
    throw new Error("Nenhum curso sendo editado");
  };

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Gerenciar Cursos">
      <CoursesTab
        courses={coursesData.courses}
        loading={coursesData.loading}
        error={coursesData.error}
        coursesPagination={coursesData.coursesPagination}
        courseSearchTerm={coursesData.courseSearchTerm}
        setCourseSearchTerm={coursesData.setCourseSearchTerm}
        onCourseSearch={() => coursesData.fetchCourses(1, coursesData.courseSearchTerm)}
        onClearCourseSearch={() => {
          coursesData.setCourseSearchTerm("");
          coursesData.fetchCourses(1, "");
        }}
        onSearchKeyPress={(e) => {
          if (e.key === "Enter") {
            coursesData.fetchCourses(1, coursesData.courseSearchTerm);
          }
        }}
        onPageChange={(page) => coursesData.fetchCourses(page, coursesData.courseSearchTerm)}
        onEditCourse={adminActions.handleEditCourse}
        onDeleteCourse={adminActions.handleDeleteCourse}
        onDeactivateCourse={adminActions.handleDeactivateCourse}
        onActivateCourse={adminActions.handleActivateCourse}
        onShowCourseForm={() => adminActions.setShowCourseForm(true)}
        onShowCreateForm={() => adminActions.setShowCreateForm(true)}
        onCoursesChange={handleCoursesChange}
      />


      {/* Course Form Modals */}
      {adminActions.showCreateForm && (
        <CourseForm
          user={user}
          onClose={() => adminActions.setShowCreateForm(false)}
          onSubmit={adminActions.handleCreateCourse}
        />
      )}

      {adminActions.editingCourse && (
        <CourseForm
          user={user}
          course={adminActions.editingCourse}
          onClose={() => adminActions.setEditingCourse(null)}
          onSubmit={handleUpdateCourseWrapper}
        />
      )}
    </AdminLayout>
  );
};

export default AdminCoursesPage;
